import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import WaterEquipmentTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";

const WaterLocationalEquipmentContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="component-energy-contents" style={{ paddingLeft: "0" }}>
      <SubHeaderBox
        subTitle={t("EQUIPMENT_LOCATION")}
        number="2.4.2a"
        isNormal={true}
      />
      {showTable && (
        <WaterEquipmentTable businessId={businessId} category={"found"} />
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default WaterLocationalEquipmentContents;
